import BlackGift from '../../../../assets/BlackGift.svg';
import {
  PickAProgramSpecialOfferBottomTitle,
  PickAProgramSpecialOfferContainer,
  PickAProgramSpecialOfferDisplay,
  PickAProgramSpecialOfferImg,
  PickAProgramSpecialOfferSubtitle,
  PickAProgramSpecialOfferTitle,
  PickAProgramSpecialOfferWrapper,
} from './PickAProgramSpecialOffer.style';

export const PickAProgramSpecialOffer = ({ desktopDisplay }: { desktopDisplay: boolean }) => {
  return (
    <PickAProgramSpecialOfferDisplay desktopDisplay={desktopDisplay}>
      <PickAProgramSpecialOfferContainer>
        <PickAProgramSpecialOfferWrapper>
          <PickAProgramSpecialOfferImg src={BlackGift} alt="BlackGift" />
          <PickAProgramSpecialOfferTitle>Special offer</PickAProgramSpecialOfferTitle>
          <PickAProgramSpecialOfferSubtitle>
            $19.9/month after the program ends to continue progress
          </PickAProgramSpecialOfferSubtitle>
        </PickAProgramSpecialOfferWrapper>
        <PickAProgramSpecialOfferBottomTitle>Trusted 160,000+ people</PickAProgramSpecialOfferBottomTitle>
      </PickAProgramSpecialOfferContainer>
    </PickAProgramSpecialOfferDisplay>
  );
};
